// Centralized backend URL + API base. Imported by every component making API calls.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
